export enum ERole {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  COMMERCIAL_ADMIN = 'commercial_admin',
}
